import { useState } from "react";
import { useDispatch } from "react-redux";
import { changeStatusOrCostPerClick } from "../../redux/actions/bidding";

import Toggle from "../shared/form/toggle";

interface Props {
  doctorId: number;
  costPerClick: number;
  status: boolean;
  balance: string;
}
const BiddingStatus = ({ doctorId, costPerClick, status, balance }: Props) => {
  const [isStatusChanging, setIsStatusChanging] = useState<boolean>(false);

  const dispatch = useDispatch();

  const changeStatus = async () => {
    if (status == true || Number(balance) > 0) {
      // enable status just for positive remaining clicks
      setIsStatusChanging(true);
      try {
        await dispatch(changeStatusOrCostPerClick(doctorId, !status, costPerClick));
      } finally {
        setIsStatusChanging(false);
      }
    } else {
      setIsStatusChanging(true);
      status = false;
      setIsStatusChanging(false);
    }
  };

  return (
    <div className="flex justify-between mt-5 text-sm font-medium" onClick={changeStatus}>
      <span>وضعیت: {status ? "فعال" : "غیر فعال"}</span>
      <Toggle value={status} loading={isStatusChanging} />
    </div>
  );
};

export default BiddingStatus;
